
import * as React from 'react';
import { Area, ResponsiveContainer, Tooltip, ComposedChart, Legend, CartesianGrid, Line, Bar, XAxis, YAxis } from 'recharts';
import { capitalize } from 'src/share/utils/utils';
import './stackedBarsChart.css'

interface IStackedBarsData {
  dataKey: string;
}

export interface IStackedBarsChartProps {
  data: IStackedBarsData[];
  dataKey: string;
  key1: string;
  key2: string;
  lineKey: string;
  loading: boolean;
}

export const StackedBarsChart: React.SFC<IStackedBarsChartProps> = (props: IStackedBarsChartProps) => {
  const { data, dataKey, key1, key2, lineKey, loading } = props;
  const existData = data.length > 0;
  const capitalKey1 = `${capitalize(key1)} images`;
  const capitalKey2 = `${capitalize(key2)} images`;
  const capitalLineKey = `${capitalize(lineKey)} detected`;
  const dataFormatted = data.map(stat => ({
    [dataKey]: stat[dataKey],
    [capitalKey1]: stat[key1],
    [capitalKey2]: stat[key2],
    [capitalLineKey]: stat[lineKey]
  }));
  return (
    <div className="stacked-bars-chart">
      {loading && <div className="skeleton-transition" />}
      <ResponsiveContainer width={'100%'} height={310} >
        <ComposedChart
          width={500}
          height={300}
          data={dataFormatted}
          className={loading ? 'loading' : ''}
          margin={{ top: 20, right: 20, left: 20, bottom: 10 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey={dataKey} />
          <YAxis />
          {!loading && <Tooltip content={(tooltipProps) => <CustomTooltip {...tooltipProps} key1={capitalKey1} key2={capitalKey2} lineKey={capitalLineKey} />} />}
          <Legend />
          {existData && <Bar isAnimationActive={!loading} dataKey={capitalKey1} stackId="stack" fill={loading ? '#E6E6E6' : '#2ABCCA'} />}
          {existData && <Bar isAnimationActive={!loading} dataKey={capitalKey2} stackId="stack" fill={loading ? '#E6E6E6' : '#E2BC2F'} />}
          {existData && <Line isAnimationActive={!loading} type="monotone" dataKey={capitalLineKey} stroke={loading ? '#E6E6E6' : '#ff7300'} activeDot={{ r: 5 }} />}
          {!existData && !loading && <Area isAnimationActive={!loading} type='monotone' dataKey='No Data to Show' stroke='grey' fill='grey' />}
        </ComposedChart>
      </ResponsiveContainer>
    </div>

  )
}

const CustomTooltip = ({ active, payload, label }) => active && payload && label ?
  <div className="custom-tooltip">
    <p className="label" style={{ marginLeft: '0px' }}>{label}</p>
    <p className="intro" style={{ color: payload[0].color, marginLeft: '0px' }}>{`${payload[0].dataKey}: ${payload[0].value}`}</p>
    <p className="intro" style={{ color: payload[1].color, marginLeft: '0px' }}>{`${payload[1].dataKey}: ${payload[1].value}`}</p>
    <p className="intro" style={{ color: payload[2].color, marginLeft: '0px' }}>{`Total ${payload[2].dataKey.toLowerCase()}: ${payload[2].value}`}</p>
    <p className="desc" style={{ color: '#A3A3A3', marginLeft: '0px' }}>{`Total images: ${(payload[0].value + payload[1].value)}`}</p>
  </div> : null


// WEBPACK FOOTER //
// ./src/share/components/Chart/StackedBarsChart.tsx